import { ColorTokens, GradientColorTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, TypographyTypeTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { View } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Card from '../card/Card';
const BankHeaderBase = ({ title, subTitle, gradientColor = GradientColorTokens.B_1, margin = {
    bottom: SizeTypeTokens.XS,
}, action, triggerAction, }) => {
    const theme = ThemeProvider.getTheme();
    return (React.createElement(Card, { gradient: {
            colors: gradientColor,
        }, margin: margin, body: {
            children: (React.createElement(View, null,
                React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                    React.createElement(Icon, { name: IconTokens.Back, size: IconSizeTokens.MD, color: ColorTokens.White, action: action, triggerAction: triggerAction }),
                    React.createElement(Space, { size: SizeTypeTokens.XXL }),
                    React.createElement(Stack, null,
                        React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween },
                            React.createElement(Typography, { label: title, numberOfLines: 1, color: ColorTokens.White, type: TypographyTypeTokens.B4 })),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        subTitle ? (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                            React.createElement(Stack, null,
                                React.createElement(Typography, { label: subTitle, type: TypographyTypeTokens.B6, color: ColorTokens.White, numberOfLines: 3 })),
                            React.createElement(Space, { size: SizeTypeTokens.XXXXL }))) : (React.createElement(React.Fragment, null))),
                    React.createElement(Space, { size: SizeTypeTokens.XXL }),
                    React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.XXXXXL, color: ColorTokens.White })))),
        } }));
};
export default memo(BankHeaderBase);
export { BankHeaderBase };
